<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div class="row">
            <div class="col">
              <b-form-group label-for="FilterStatType" label="Stat">
                <b-form-select id="FilterStatType" :options="activityTypesList" v-model="filter.activityType" style="width: 200px;">
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label-for="FilterInterval" label="Date Range">
                <b-form-select id="FilterInterval" :options="intervalList" v-model="filter.interval" class="float-left">
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label-for="FilterIncludeCurrent" label="Include Current">
                <b-form-checkbox v-model="filter.includeCurrent" id="FilterIncludeCurrent">{{includeCurrentDisplay}}</b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col text-center">
              <button class="btn btn-primary mt-4" @click="getItems()" v-if="!applying">Apply Filters</button>
              <img src="/img/wifi-loading.gif" alt="loading" class="loading-button" v-if="applying">
            </div>
          </div>
        </b-card>
        <b-card>
          <div slot="header">
            Line
          </div>
          <b-card-body>
            <div class="mb-4" style="min-height: 450px;">
              <div v-if="applying || !chartReady" class="table-loading-container">
                <img src="/img/wifi-loading.gif" alt="loading" class="loading-table">
              </div>
              <div v-if="chartReady && !applying">
                <line-chart :chart-data="activityChart" :options="chartOptions" :height="200"></line-chart>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Confirm Delete" class="modal-danger" v-model="deleteModal" @ok="confirmDelete()" ok-variant="danger">
      <div><b>Are you sure you want to delete this activity?</b></div>
      <div>{{selectedItem.name}}</div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import common from './../../mixins/common'
import LineChart from './../charts/LineChart'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  name: 'charts',
  components: {
    LineChart
  },
  data () {
    return {
      selectedItem: {},
      deleteModal: false,
      filter: {
        activityType: 'register-user',
        interval: '7-days',
        includeCurrent: true
      },
      chartLabel: 'Ad Views',
      applying: false
    }
  },
  mixins: [common],
  computed: {
    chartOptions () {
      let scope = this;
      return {
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              callback: function(value, index, values) {
                return Math.floor(value);
              }
            }
          }]
        }
      }
    },
    activityChart () {
      // let activityChart = {
      //   labels: question.options.map(option => option.optionName),
      //   datasets: [
      //     {
      //       label: question.questionName,
      //       backgroundColor: hexToRgba('#592b8b', 10),
      //       borderColor: '#592b8b',
      //       pointHoverBackgroundColor: '#fff',
      //       borderWidth: 1,
      //       data: question.options.map(option => option.optionCount)
      //     }
      //   ]
      // }
      let scope = this;
      let activityChart = {
        labels: scope.activityCharts.map(activity => activity.label),
        datasets: [
          {
            label: scope.chartLabel,
            backgroundColor: hexToRgba('#592b8b', 10),
            borderColor: '#592b8b',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: scope.activityCharts.map(activity => activity.count)
          }
        ]
      }

      return activityChart;
    },
    activityCharts () {
      return this.$store.getters.activityCharts;
    },
    activityTypesList () {
      let activityTypes = [];
      activityTypes.push({text: 'Ad Views', value: 'view-ad'});
      activityTypes.push({text: 'Ad Clicks', value: 'click-ad'});
      activityTypes.push({text: 'Survey Views', value: 'view-survey'});
      activityTypes.push({text: 'Survey Starts', value: 'start-survey'});
      activityTypes.push({text: 'Survey Completes', value: 'complete-survey'});
      activityTypes.push({text: 'User Registrations', value: 'register-user'});
      return activityTypes;
    },
    intervalList () {
      let intervals = [];
      intervals.push({text: 'Last 7 days', value: '7-days'});
      intervals.push({text: 'Last 4 weeks', value: '4-weeks'});
      intervals.push({text: 'Last 3 months', value: '3-months'});
      return intervals;
    },
    includeCurrentDisplay () {
      if(this.filter.interval.indexOf('days') > -1) {
        return 'Day';
      } else if(this.filter.interval.indexOf('months') > -1) {
        return 'Month';
      } else if(this.filter.interval.indexOf('weeks') > -1) {
        return 'Week';
      }
      return '';
    },
    chartReady () {
      if(this.activityCharts.length > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    getItems: function () {
      let scope = this;
      scope.applying = true;
      scope.$store.dispatch('getActivityCharts', {
        activityType: scope.filter.activityType,
        interval: scope.filter.interval.split('-')[1],
        last: scope.filter.interval.split('-')[0],
        includeCurrent: scope.filter.includeCurrent
        }).then(result => {
          scope.chartLabel = _.find(scope.activityTypesList, activityType => activityType.value === scope.filter.activityType).text;
          scope.applying = false;
      }, error => {
        console.log(error);
        scope.applying = false;
      });
    },
    deleteItem: function (selItem) {
      this.selectedItem = selItem;
      this.deleteModal = true;
    },
    confirmDelete: function () {
      this.deleteModal = false;
      let scope = this;
      axios.delete(process.env.VUE_APP_API + '/activity/' + scope.selectedItem._id, {
        headers: {
          Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
          }
        })
          .then(function (response) {
            scope.getItems()
          })
          .catch(function (error) {
            console.log(error);
          });
    }
  },
  created () {    
    this.getItems();
  }
}
</script>
